// src/layouts/corui/routesCore.js
import React from 'react'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
const Typography = React.lazy(() => import('./views/theme/typography/Typography'))

// Base
const Accordion = React.lazy(() => import('./views/base/accordion/Accordion'))
const Breadcrumbs = React.lazy(() => import('./views/base/breadcrumbs/Breadcrumbs'))
const Cards = React.lazy(() => import('./views/base/cards/Cards'))
const Carousels = React.lazy(() => import('./views/base/carousels/Carousels'))
const Collapses = React.lazy(() => import('./views/base/collapses/Collapses'))
const ListGroups = React.lazy(() => import('./views/base/list-groups/ListGroups'))
const Navs = React.lazy(() => import('./views/base/navs/Navs'))
const Paginations = React.lazy(() => import('./views/base/paginations/Paginations'))
const Placeholders = React.lazy(() => import('./views/base/placeholders/Placeholders'))
const Popovers = React.lazy(() => import('./views/base/popovers/Popovers'))
const Progress = React.lazy(() => import('./views/base/progress/Progress'))
const Spinners = React.lazy(() => import('./views/base/spinners/Spinners'))
const Tabs = React.lazy(() => import('./views/base/tabs/Tabs'))
const Tables = React.lazy(() => import('./views/base/tables/Tables'))
const Tooltips = React.lazy(() => import('./views/base/tooltips/Tooltips'))

// Buttons
const Buttons = React.lazy(() => import('./views/buttons/buttons/Buttons'))
const ButtonGroups = React.lazy(() => import('./views/buttons/button-groups/ButtonGroups'))
const Dropdowns = React.lazy(() => import('./views/buttons/dropdowns/Dropdowns'))

//Forms
const ChecksRadios = React.lazy(() => import('./views/forms/checks-radios/ChecksRadios'))
const FloatingLabels = React.lazy(() => import('./views/forms/floating-labels/FloatingLabels'))
const FormControl = React.lazy(() => import('./views/forms/form-control/FormControl'))
const InputGroup = React.lazy(() => import('./views/forms/input-group/InputGroup'))
const Layout = React.lazy(() => import('./views/forms/layout/Layout'))
const Range = React.lazy(() => import('./views/forms/range/Range'))
const Select = React.lazy(() => import('./views/forms/select/Select'))
const Validation = React.lazy(() => import('./views/forms/validation/Validation'))

const Charts = React.lazy(() => import('./views/charts/Charts'))

// Icons
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'))
const Flags = React.lazy(() => import('./views/icons/flags/Flags'))
const Brands = React.lazy(() => import('./views/icons/brands/Brands'))

// Notifications
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'))
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'))
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'))
const Toasts = React.lazy(() => import('./views/notifications/toasts/Toasts'))

const Widgets = React.lazy(() => import('./views/widgets/Widgets'))


const routesCore = [
    { path: '/core', exact: true, name: 'Dashboard' },
   { path: '/core/dashboard', name: 'Dashboard', element: Dashboard },
   { path: '/core/theme', name: 'Theme', element: Colors, exact: true },
   { path: '/core/theme/colors', name: 'Colors', element: Colors },
   { path: '/core/theme/typography', name: 'Typography', element: Typography },
   { path: '/core/base', name: 'Base', element: Cards, exact: true },
   { path: '/core/base/accordion', name: 'Accordion', element: Accordion },
   { path: '/core/base/breadcrumbs', name: 'Breadcrumbs', element: Breadcrumbs },
   { path: '/core/base/cards', name: 'Cards', element: Cards },
   { path: '/core/base/carousels', name: 'Carousel', element: Carousels },
   { path: '/core/base/collapses', name: 'Collapse', element: Collapses },
   { path: '/core/base/list-groups', name: 'List Groups', element: ListGroups },
   { path: '/core/base/navs', name: 'Navs', element: Navs },
   { path: '/core/base/paginations', name: 'Paginations', element: Paginations },
   { path: '/core/base/placeholders', name: 'Placeholders', element: Placeholders },
   { path: '/core/base/popovers', name: 'Popovers', element: Popovers },
   { path: '/core/base/progress', name: 'Progress', element: Progress },
   { path: '/core/base/spinners', name: 'Spinners', element: Spinners },
   { path: '/core/base/tabs', name: 'Tabs', element: Tabs },
   { path: '/core/base/tables', name: 'Tables', element: Tables },
   { path: '/core/base/tooltips', name: 'Tooltips', element: Tooltips },
   { path: '/core/buttons', name: 'Buttons', element: Buttons, exact: true },
   { path: '/core/buttons/buttons', name: 'Buttons', element: Buttons },
   { path: '/core/buttons/dropdowns', name: 'Dropdowns', element: Dropdowns },
   { path: '/core/buttons/button-groups', name: 'Button Groups', element: ButtonGroups },
   { path: '/core/charts', name: 'Charts', element: Charts },
   { path: '/core/forms', name: 'Forms', element: FormControl, exact: true },
   { path: '/core/forms/form-control', name: 'Form Control', element: FormControl },
   { path: '/core/forms/select', name: 'Select', element: Select },
   { path: '/core/forms/checks-radios', name: 'Checks & Radios', element: ChecksRadios },
   { path: '/core/forms/range', name: 'Range', element: Range },
   { path: '/core/forms/input-group', name: 'Input Group', element: InputGroup },
   { path: '/core/forms/floating-labels', name: 'Floating Labels', element: FloatingLabels },
   { path: '/core/forms/layout', name: 'Layout', element: Layout },
   { path: '/core/forms/validation', name: 'Validation', element: Validation },
   { path: '/core/icons', exact: true, name: 'Icons', element: CoreUIIcons },
   { path: '/core/icons/coreui-icons', name: 'CoreUI Icons', element: CoreUIIcons },
   { path: '/core/icons/flags', name: 'Flags', element: Flags },
   { path: '/core/icons/brands', name: 'Brands', element: Brands },
   { path: '/core/notifications', name: 'Notifications', element: Alerts, exact: true },
   { path: '/core/notifications/alerts', name: 'Alerts', element: Alerts },
   { path: '/core/notifications/badges', name: 'Badges', element: Badges },
   { path: '/core/notifications/modals', name: 'Modals', element: Modals },
   { path: '/core/notifications/toasts', name: 'Toasts', element: Toasts },
   { path: '/core/widgets', name: 'Widgets', element: Widgets },
]

export default routesCore
